import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getMemeDetails } from '@opm/services';
import { useEffect, useState } from 'react';

export function useMemeDetails({ filter }: { filter: any }) {
  const [data, setData] = useState<any>({});
  const { wrapperCancelRequest, loading } = useCancelRequestHook();

  function request() {
    if (!filter?.meme_title) return;
    wrapperCancelRequest(getMemeDetails, filter)
      .then(data => {
        setData(data);
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (filter) {
      request();
    }
  }, [filter]);

  return {
    data,
    loading,
  };
}
